import { useEffect, useRef } from 'react';

let helpers = {
   deepEqual: (a, b) => {
      if (
         typeof a == 'object' &&
         a != null &&
         typeof b == 'object' &&
         b != null
      ) {
         var count = [0, 0];
         for (var key in a) count[0]++;
         for (var key in b) count[1]++;
         if (count[0] - count[1] != 0) {
            return false;
         }
         for (var key in a) {
            if (!(key in b) || !helpers.deepEqual(a[key], b[key])) {
               return false;
            }
         }
         for (var key in b) {
            if (!(key in a) || !helpers.deepEqual(b[key], a[key])) {
               return false;
            }
         }
         return true;
      } else {
         return a === b;
      }
   },
   turnObjectPropertiesIntoArrayOfNames: o => {
      let a = [];

      if (o)
         for (let p in o) {
            a.push(p);
         }

      return a;
   },
   getAuthToken: () => {
      let hasFailed = true;

      let authTokenJSON = window.localStorage.getItem('authToken');
      let authTokenOBJ = authTokenJSON ? JSON.parse(authTokenJSON) : null;

      if (authTokenOBJ && authTokenOBJ.authToken) {
         hasFailed = false;
      } else window.localStorage.removeItem('authToken');

      return {
         authToken: authTokenOBJ ? authTokenOBJ.authToken : null,
         retrieveAuthTokenFailed: hasFailed,
      };
   },
   usePrevious: value => {
      // The ref object is a generic container whose current property is mutable ...
      // ... and can hold any value, similar to an instance property on a class
      const ref = useRef();
      // Store current value in ref
      useEffect(() => {
         ref.current = value;
      }, [value]); // Only re-run if value changes
      // Return previous value (happens before update in useEffect above)
      return ref.current;
   },
   removeArrayOfCharsFromString: (string, charArr) => {
      let formatedSting = string;
      charArr.forEach(char => {
         formatedSting = helpers.removeAllCharactersFromString(
            formatedSting,
            char
         );
      });
      return formatedSting;
   },
   removeAllCharactersFromString: (string, char) => {
      while (string.indexOf(char) >= 0) {
         string = string.replace(char, '');
      }
      return string;
   },
};
export default helpers;
